/* eslint-disable max-len */
import { GridToolbarContainer } from '@mui/x-data-grid';

import { ExportOptions, TOption, TypeButtons } from '../ExportOptions';
import { DropdownGridToolbarOption } from './DropdownGridToolbarOption';

export type TFormat = 'PDF' | 'CSV' | 'XLSX';

interface Props {
  fileName?: string;
  filterButton?: TypeButtons;
  handleUploadFile?: (data: {
    fileContent: string;
    fileName: string;
    description: string;
  }) => void;
  headerToExport?: { label: string; key: string }[];
  isExport?: boolean;
  isLandscapePDF: boolean;
  isSendingEmail?: boolean;
  itemsSelectedToExport?: { [key: string]: unknown }[];
  itemsToExport?: { [key: string]: unknown }[];
  maximRowToExport?: number;
  onExport: (selectedOption?: TOption) => void;
  typeFormatExport?: (type: string) => string;
  limitCSVandXLSX: boolean;
  rowCount: number;
  sendEmailBase64?: boolean;
  setExportOption: (data: TFormat) => void;
}

export function CustomToolbar({
  fileName,
  filterButton,
  handleUploadFile,
  headerToExport,
  isExport,
  isLandscapePDF = false,
  isSendingEmail = false,
  itemsSelectedToExport,
  itemsToExport,
  maximRowToExport,
  limitCSVandXLSX = false,
  onExport,
  typeFormatExport,
  rowCount,
  sendEmailBase64 = false,
  setExportOption
}: Props) {
  return (
    <GridToolbarContainer sx={{ justifyContent: 'space-between' }}>
      <DropdownGridToolbarOption />

      {isExport && (
        <ExportOptions
          fileName={fileName}
          filterButton={filterButton}
          handleUploadFile={handleUploadFile}
          headers={headerToExport}
          isLandscapePDF={isLandscapePDF}
          isSendingEmail={isSendingEmail}
          items={
            itemsSelectedToExport?.length
              ? itemsSelectedToExport
              : itemsToExport
          }
          limitCSVandXLSX={limitCSVandXLSX}
          maximRowToExportPDF={maximRowToExport}
          messageErrorPDF={`La exportación excede los ${maximRowToExport} registros permitidos, favor de filtrar su consulta`}
          onExport={(selectedOption: TOption) =>
            !itemsSelectedToExport?.length && onExport(selectedOption)
          }
          sendEmailBase64={sendEmailBase64}
          setExportOption={setExportOption}
          totalCount={itemsSelectedToExport?.length || rowCount}
          typeFormatExport={typeFormatExport}
        />
      )}
    </GridToolbarContainer>
  );
}
